module.exports = __webpack_public_path__ + "img/price-quote-icon.acb2fbb3.svg";